<template>
  <div class="taskpop" @click="gotoTask">
    <el-image style="width: 100%; height: 100%;" 
    :src="require('../assets/img/textform/taskpop.png')"
    fit="contain" 
    class="bouncing"
    >
      <div slot="placeholder" class="image-slot"></div>
    </el-image>

    <el-image style="width: 20px; height: 20px;position: absolute;right: 24px;top: 26px;z-index: 999;" 
    :src="require('../assets/img/textform/close2.png')"
    fit="contain" @click.stop="closePop">
      <div slot="placeholder" class="image-slot"></div>
    </el-image>
  </div>
  
</template>

<script>
export default {
  methods:{
    closePop(){
      this.$emit('closePopEmit', false );
    } ,
    gotoTask(){
      let obj = {} ;
      obj.router = "taskCenter"  ;
      this.$router.push({
        name: "test", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
        params: obj
      });
    }
  }
}

</script>

<style lang="scss" scoped>
.taskpop {
  position: fixed;
  left: 16px;
  bottom: 11px;
  width: 260px;
  height: 280px;
}

.bouncing {
  animation : rubberband 1200ms infinite alternate ease-out;
}
@keyframes rubberband {
    0%{
        transform: scaleX(1);
    }
    40%{
        transform: scaleX(1.04) scaleY(0.75);
    }
    55%{
        transform: scaleX(0.96) scaleY(1);
    }
    65%{
        transform: scaleX(1.06) scaleY(0.85);
    }
    75%{
        transform: scaleX(0.94)  scaleY(1);
    }
    90%{
        transform: scaleX(1.02) scaleY(0.95);
    }
    100%{
        transform: scaleX(1) scaleY(1);
    }
}


</style>